import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `anisotropic_filtering_level` the textures below draw at. A viewport takes the project's
 * level at construction (`viewport.cpp:5384`) and a SubViewport may set its own, so a portal's
 * subtree provides the authored level and every other subtree reads the project's.
 */
import { createContext, useContext } from 'react';
import { projectAnisotropicFilteringLevel } from '../../parser/projectSettingsParser';
import { useProjectSettings } from './ProjectSettingsContext';
/** Undefined: the viewport above authors no level, so the project's holds. */
const AnisotropicFilteringContext = createContext(undefined);
AnisotropicFilteringContext.displayName = 'AnisotropicFilteringContext';
export function AnisotropicFilteringProvider({ level, children, }) {
    return (_jsx(AnisotropicFilteringContext.Provider, { value: level, children: children }));
}
export function useAnisotropicFilteringLevel() {
    const viewportLevel = useContext(AnisotropicFilteringContext);
    const { settings } = useProjectSettings();
    return viewportLevel ?? projectAnisotropicFilteringLevel(settings);
}
//# sourceMappingURL=AnisotropicFilteringContext.js.map